import React, { useState, useEffect } from "react";
import Header from "../../common/layout/header";
import Footer from "../../common/layout/footer";
import Sidebar from "../../common/sidebar";
import ShowAlert from "../../common/Showalert";
import CommonAlert from "../../common/Commonalert";
import { http } from "../../helper";
import { BaseUrl } from "../../common/config";
import { useParams } from "react-router-dom";
import RichTextEditor from "../../common/richTextEditor";
import { useTranslation } from "react-i18next";

const FAQEdit = () => {
  const { t } = useTranslation();
  const { id } = useParams(); // FAQ ID from URL
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [status, setStatus] = useState("A");
  const [errors, setErrors] = useState({});
  const [alertSuccess, setAlertSuccess] = useState(false);
  const [alertError, setAlertError] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [redirectPath, setRedirectPath] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  if (!sessionStorage.getItem("isLoggedIn")) window.location.href = "/";

  const auth = JSON.parse(sessionStorage.getItem("authData"));
  if (auth && !auth.adminRole.permissions.includes("manage_vendorhub")) {
    window.location.href = "/unauthorized";
  }

  const goBack = () => {
    window.location.href = `/vendorhub/faq`;
  };

  // Fetch selected FAQ details
  useEffect(() => {
    fetchFAQ();
  }, []);

  const fetchFAQ = () => {
    const URL = BaseUrl + `admin/faq/${id}`;
    setIsLoading(true);
    http
      .get(URL)
      .then((response) => {
        if (response.data.success) {
          const d = response.data.data;
          setQuestion(d.question);
          setAnswer(d.answer);
          setStatus(d.status);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
        setAlertError(true);
        setAlertMessage(t("failed_to_load_faq"));
      });
  };

  const validateForm = () => {
    const err = {};
    let valid = true;
    if (!question.trim()) {
      err.question = t("field_require_txt");
      valid = false;
    }
    if (!answer.trim()) {
      err.answer = t("field_require_txt");
      valid = false;
    }
    setErrors(err);
    return valid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    const payload = {
      question,
      answer,
      status,
    };
    const URL = BaseUrl + `admin/editfaq/${id}`;
    http
      .put(URL, payload)
      .then((response) => {
        if (response.data.success) {
          setIsLoading(false);
          setAlertSuccess(true);
          setAlertMessage(t("faq_updated_successfully"));
          setRedirectPath("/vendorhub/faq");
        }
      })
      .catch((err) => {
        console.log(err);
        setAlertError(true);
        setAlertMessage(t("faq_update_failed"));
      });
  };

  return (
    <section className="dashboard-block">
      {alertSuccess && (
        <CommonAlert
          title={t("alert_txt")}
          message={alertMessage}
          redirectTo={redirectPath}
        />
      )}
      {alertError && <ShowAlert title={t("error_txt")} message={alertMessage} />}
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          <div className="container account-details">
            <h1 className="checkout-title">{t("edit_faq_txt")}</h1>
            <div className="right-table-outer-wrap">
              {isLoading ? (
                <div className="loading-buffer"></div>
              ) : (
                <form className="sectors-detail-form">
                  <div className="input-field">
                    <label htmlFor="question">{t("faq_question_txt")}</label>
                    <input
                      type="text"
                      name="question"
                      value={question}
                      onChange={(e) => {
                        setQuestion(e.target.value);
                        setErrors((prev) => ({ ...prev, question: "" }));
                      }}
                    />
                    {errors.question && (
                      <div className="error-msg">{errors.question}</div>
                    )}
                  </div>
                  <div className="input-field">
                    <label htmlFor="answer">{t("faq_answer_txt")}</label>
                    <div className="email-editor-wrapper">
                      <RichTextEditor
                        emailContent={answer}
                        handleChangeEmailContent={(html) => {
                          setAnswer(html);
                          setErrors((prev) => ({ ...prev, answer: "" }));
                        }}
                        readOnly={false}
                      />
                    </div>
                  </div>
                  <div className="flex-bx-wrap col3">
                    <div className="flex-bx-item">
                      <div className="input-field">
                        <label>{t("status_txt")}</label>
                        <select
                          name="status"
                          value={status}
                          onChange={(e) => setStatus(e.target.value)}
                        >
                          <option value="A">{t("active_txt")}</option>
                          <option value="I">{t("inactive_txt")}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="btnfield">
                    <button type="submit" onClick={handleSubmit}>
                      {t("update_btn_txt")}
                    </button>
                    &nbsp;&nbsp;&nbsp;
                    <button type="button" onClick={goBack}>
                      {t("cancel_txt")}
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
          <Footer />
        </section>
      </div>
    </section>
  );
};

export default FAQEdit;
